import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import Menu from '../myComponents/Menu';
import './SetupPlatformPage.css';
import Footer from '../myComponents/Footer';

const SetupRouterPage = () => {
  const [activeIndex, setActiveIndex] = useState(null);
  const [activeTab, setActiveTab] = useState(0);

  const toggleSection = (index) => {
    setActiveIndex(activeIndex === index ? null : index);
  };

  return (
    <div className="App">
      <div style={{ position: 'relative', zIndex: 1000 }}>
        <Menu />
      </div>
      
      <section className="platform-setup-section">
        <div className="platform-container">
          {/* Header */}
          <div className="platform-header">
            <div className="platform-breadcrumb">
              <Link to="/setup">
                ← Все инструкции
              </Link>
            </div>
            <h1 className="platform-title">Как установить VPN на роутере</h1>
            <p className="platform-description">
              RED BUTTON предлагает настройку VPN на роутерах с альтернативной прошивкой. Это технически сложный процесс, требующий специального оборудования, навыков работы с Linux и ручной настройки VLESS конфигурации.<br/><br/>
              
              После настройки ВСЕ устройства в сети автоматически получат VPN защиту без установки приложений.<br/><br/>
              
              <strong>⚠️ КРИТИЧЕСКИЕ ПРЕДУПРЕЖДЕНИЯ:</strong><br/>
              • Прошивка роутера ПОЛНОСТЬЮ аннулирует гарантию<br/>
              • Неправильные действия могут превратить роутер в "кирпич"<br/>
              • Некоторые модели НЕВОЗМОЖНО восстановить после неудачной прошивки<br/>
              • Требуются серьезные навыки работы с Linux/SSH<br/>
              • Процесс занимает 3-5 часов даже у опытных пользователей<br/>
              • <strong>Рекомендуется ТОЛЬКО для IT-специалистов</strong><br/><br/>
              
              <strong>Что потребуется:</strong><br/>
              • USB флешка 8GB+ (для большинства моделей)<br/>
              • Кабель Ethernet<br/>
              • Компьютер с SSH клиентом<br/>
              • Стабильный интернет<br/>
              • 3-5 часов времени<br/>
              • Опыт работы с командной строкой Linux
            </p>
          </div>

          {/* App Tabs */}
          <div className="app-tabs">
            <div 
              className={`tab ${activeTab === 0 ? 'active' : ''}`}
              onClick={() => setActiveTab(0)}
            >
              Keenetic
            </div>
            <div 
              className={`tab ${activeTab === 1 ? 'active' : ''}`}
              onClick={() => setActiveTab(1)}
            >
              ASUS Merlin
            </div>
            <div 
              className={`tab ${activeTab === 2 ? 'active' : ''}`}
              onClick={() => setActiveTab(2)}
            >
              OpenWrt
            </div>
          </div>

          {/* Setup Steps */}
          <div className="setup-steps">
            
            {/* Keenetic Tab */}
            {activeTab === 0 && (
              <>
                <div className="tab-text-content">
                  <p>Keenetic - относительно простой вариант настройки VPN на роутере. Многие модели поддерживают установку пакетов через Entware.</p>
                  
                  <h1>Поддерживаемые модели Keenetic</h1>
                  
                  <p><strong>✅ С USB портом (нужна флешка 8GB+):</strong><br/>
                  • Keenetic Giga (KN-1010/1011) - от 8000₽<br/>
                  • Keenetic Ultra (KN-1810/1811) - от 12000₽<br/>
                  • Keenetic Peak (KN-2710) - от 15000₽<br/>
                  • Keenetic Speedster (KN-3010) - от 18000₽<br/>
                  • Keenetic Hero 4G (KN-2310)<br/>
                  • Keenetic Viva (KN-1910), Carrier (KN-2010/2110/2410/2510)</p>
                  
                  <p><strong>✅ Новые модели (можно без флешки):</strong><br/>
                  • Keenetic Peak (KN-2710)<br/>
                  • Keenetic Titan (KN-1811)<br/>
                  • Keenetic Hero (KN-1012)<br/>
                  • Keenetic Hopper (KN-3811/3812)</p>
                  
                  <p><strong>❌ НЕ поддерживаются:</strong><br/>
                  • Keenetic Start, Air, 4G (бюджетные без USB)<br/>
                  • Старые модели до 2018 года</p>
                </div>

                <div className="setup-section">
                  <button
                    className={`section-header ${activeIndex === 0 ? 'active' : ''}`}
                    onClick={() => toggleSection(0)}
                  >
                    <h3>ШАГ 1: Подготовка USB флешки (если нужна)</h3>
                    <span className="section-icon">
                      {activeIndex === 0 ? '−' : '+'}
                    </span>
                  </button>
                  
                  <div className={`section-content ${activeIndex === 0 ? 'active' : ''}`}>
                    <div className="section-content-inner">
                      <ol className="steps-list">
                        <li>Возьмите USB флешку 8GB+ (можно обычную USB 2.0)</li>
                        <li>В Windows скачайте программу "Rufus"</li>
                        <li>В Rufus выберите флешку и файловую систему "EXT4"</li>
                        <li>Нажмите "Start" и дождитесь форматирования</li>
                      </ol>
                      <p><strong>Примечание:</strong> EXT4 не читается в Windows после форматирования - это нормально!</p>
                    </div>
                  </div>
                </div>

                <div className="setup-section">
                  <button
                    className={`section-header ${activeIndex === 1 ? 'active' : ''}`}
                    onClick={() => toggleSection(1)}
                  >
                    <h3>ШАГ 2: Базовая настройка роутера</h3>
                    <span className="section-icon">
                      {activeIndex === 1 ? '−' : '+'}
                    </span>
                  </button>
                  
                  <div className={`section-content ${activeIndex === 1 ? 'active' : ''}`}>
                    <div className="section-content-inner">
                      <ol className="steps-list">
                        <li>Подключите роутер к компьютеру кабелем Ethernet</li>
                        <li>Если используете флешку - вставьте в USB порт роутера</li>
                        <li>Откройте браузер: http://192.168.1.1</li>
                        <li>Войдите (обычно admin/admin или admin/пустой пароль)</li>
                      </ol>
                    </div>
                  </div>
                </div>

                <div className="setup-section">
                  <button
                    className={`section-header ${activeIndex === 2 ? 'active' : ''}`}
                    onClick={() => toggleSection(2)}
                  >
                    <h3>ШАГ 3: Включение компонентов</h3>
                    <span className="section-icon">
                      {activeIndex === 2 ? '−' : '+'}
                    </span>
                  </button>
                  
                  <div className={`section-content ${activeIndex === 2 ? 'active' : ''}`}>
                    <div className="section-content-inner">
                      <ol className="steps-list">
                        <li>Перейдите в "Общие настройки" → "Обновления и компоненты"</li>
                        <li>Нажмите "Компоненты"</li>
                        <li>Установите компоненты:
                          <ul>
                            <li>✅ "Поддержка пакетов OPKG"</li>
                            <li>✅ "Файловая система Ext"</li>
                            <li>✅ "Доступ по SSH"</li>
                          </ul>
                        </li>
                        <li>Создайте пароль для SSH (минимум 8 символов)</li>
                        <li>Нажмите "Сохранить" и дождитесь перезагрузки</li>
                      </ol>
                    </div>
                  </div>
                </div>

                <div className="setup-section">
                  <button
                    className={`section-header ${activeIndex === 3 ? 'active' : ''}`}
                    onClick={() => toggleSection(3)}
                  >
                    <h3>ШАГ 4: Установка Entware</h3>
                    <span className="section-icon">
                      {activeIndex === 3 ? '−' : '+'}
                    </span>
                  </button>
                  
                  <div className={`section-content ${activeIndex === 3 ? 'active' : ''}`}>
                    <div className="section-content-inner">
                      <p><strong>Вариант A: На флешку (для старых моделей)</strong></p>
                      <ol className="steps-list">
                        <li>Перейдите в "Приложения" → "USB накопители"</li>
                        <li>Выберите вашу флешку</li>
                        <li>Нажмите "Настроить Entware"</li>
                        <li>Дождитесь установки (10-15 минут)</li>
                      </ol>
                      
                      <p><strong>Вариант B: Во внутреннюю память (для новых моделей)</strong></p>
                      <ol className="steps-list">
                        <li>Перейдите в "Приложения" → "Внутренняя память"</li>
                        <li>Создайте папку "install"</li>
                        <li>Скачайте installer архив для вашей модели:
                          <ul>
                            <li>Для большинства: EN_mipsel-installer.tar.gz</li>
                            <li>Для Titan KN-1811: EN_aarch64-installer.tar.gz</li>
                          </ul>
                        </li>
                        <li>Загрузите файл в папку install</li>
                        <li>В CLI выполните: opkg disk storage:/</li>
                      </ol>
                    </div>
                  </div>
                </div>

                <div className="setup-section">
                  <button
                    className={`section-header ${activeIndex === 4 ? 'active' : ''}`}
                    onClick={() => toggleSection(4)}
                  >
                    <h3>ШАГ 5: Получение VLESS конфигурации</h3>
                    <span className="section-icon">
                      {activeIndex === 4 ? '−' : '+'}
                    </span>
                  </button>
                  
                  <div className={`section-content ${activeIndex === 4 ? 'active' : ''}`}>
                    <div className="section-content-inner">
                      <p><strong>ВАЖНО:</strong> Роутеры НЕ поддерживают subscription-ссылки! Нужна отдельная VLESS конфигурация.</p>
                      <ol className="steps-list">
                        <li>Откройте Telegram бот RED BUTTON</li>
                        <li>Перейдите в "Мои конфигурации"</li>
                        <li>Выберите "Отдельные конфиги" (НЕ подписку!)</li>
                        <li>Скопируйте VLESS строку типа:<br/>
                        <span className="router-code">vless://uuid@сервер:порт?encryption=none&security=reality&sni=домен&fp=chrome&pbk=ключ&sid=короткийid&type=tcp&headerType=none#название</span></li>
                      </ol>
                    </div>
                  </div>
                </div>

                <div className="setup-section">
                  <button
                    className={`section-header ${activeIndex === 5 ? 'active' : ''}`}
                    onClick={() => toggleSection(5)}
                  >
                    <h3>ШАГ 6: Подключение по SSH и установка Xray</h3>
                    <span className="section-icon">
                      {activeIndex === 5 ? '−' : '+'}
                    </span>
                  </button>
                  
                  <div className={`section-content ${activeIndex === 5 ? 'active' : ''}`}>
                    <div className="section-content-inner">
                      <p>В Windows используйте PuTTY, в Linux/Mac - терминал</p>
                      <div className="router-code-block">
{`# Подключение к роутеру
ssh admin@192.168.1.1

# Введите SSH пароль

# Обновите пакеты
opkg update

# Установите необходимые инструменты  
opkg install curl wget unzip nano

# Скачайте Xray (для большинства Keenetic - ARM)
cd /tmp

# Скачиваем Xray
wget https://github.com/XTLS/Xray-core/releases/download/v1.8.6/Xray-linux-arm32-v7a.zip

# Распакуйте и установите
unzip Xray-linux-arm32-v7a.zip
cp xray /opt/usr/bin/
chmod +x /opt/usr/bin/xray

# Создайте папки
mkdir -p /opt/etc/xray
mkdir -p /opt/var/log/xray`}
                      </div>
                    </div>
                  </div>
                </div>

                <div className="setup-section">
                  <button
                    className={`section-header ${activeIndex === 6 ? 'active' : ''}`}
                    onClick={() => toggleSection(6)}
                  >
                    <h3>ШАГ 7: Парсинг VLESS конфигурации</h3>
                    <span className="section-icon">
                      {activeIndex === 6 ? '−' : '+'}
                    </span>
                  </button>
                  
                  <div className={`section-content ${activeIndex === 6 ? 'active' : ''}`}>
                    <div className="section-content-inner">
                      <p>Из VLESS строки нужно вручную выделить параметры:</p>
                      
                      <p><strong>Пример VLESS строки:</strong><br/>
                      <span className="router-code">vless://5783a3e7-e373-51cd-8642-c83782b807c5@example.com:443?encryption=none&security=reality&sni=microsoft.com&fp=chrome&pbk=SLwVMXPGdOx_B7UHLjKlCXWkl0sbLI&sid=6ba85179e30d4fc2&type=tcp&headerType=none#MyServer</span></p>
                      
                      <p><strong>Расшифровка параметров:</strong><br/>
                      • <strong>UUID:</strong> 5783a3e7-e373-51cd-8642-c83782b807c5<br/>
                      • <strong>Сервер:</strong> example.com<br/>
                      • <strong>Порт:</strong> 443<br/>
                      • <strong>SNI:</strong> microsoft.com<br/>
                      • <strong>Public Key:</strong> SLwVMXPGdOx_B7UHLjKlCXWkl0sbLI<br/>
                      • <strong>Short ID:</strong> 6ba85179e30d4fc2</p>
                    </div>
                  </div>
                </div>

                <div className="setup-section">
                  <button
                    className={`section-header ${activeIndex === 7 ? 'active' : ''}`}
                    onClick={() => toggleSection(7)}
                  >
                    <h3>ШАГ 8: Создание конфигурации Xray</h3>
                    <span className="section-icon">
                      {activeIndex === 7 ? '−' : '+'}
                    </span>
                  </button>
                  
                  <div className={`section-content ${activeIndex === 7 ? 'active' : ''}`}>
                    <div className="section-content-inner">
                      <div className="router-code-block">
{`# Создайте конфиг файл
nano /opt/etc/xray/config.json`}
                      </div>
                      
                      <p>Вставьте конфигурацию, заменив параметры на свои:</p>
                      
                      <div className="router-code-block">
{`{
  "log": {
    "loglevel": "warning"
  },
  "inbounds": [
    {
      "tag": "transparent",
      "port": 12345,
      "protocol": "dokodemo-door",
      "settings": {
        "network": "tcp,udp",
        "followRedirect": true
      },
      "streamSettings": {
        "sockopt": {
          "tproxy": "tproxy",
          "mark": 255
        }
      }
    }
  ],
  "outbounds": [
    {
      "tag": "proxy",
      "protocol": "vless", 
      "settings": {
        "vnext": [
          {
            "address": "example.com",
            "port": 443,
            "users": [
              {
                "id": "5783a3e7-e373-51cd-8642-c83782b807c5",
                "encryption": "none",
                "flow": "xtls-rprx-vision"
              }
            ]
          }
        ]
      },
      "streamSettings": {
        "network": "tcp",
        "security": "reality",
        "realitySettings": {
          "serverName": "microsoft.com",
          "fingerprint": "chrome",  
          "publicKey": "SLwVMXPGdOx_B7UHLjKlCXWkl0sbLI",
          "shortId": "6ba85179e30d4fc2"
        }
      }
    },
    {
      "tag": "direct",
      "protocol": "freedom"
    }
  ],
  "routing": {
    "domainStrategy": "IPIfNonMatch",
    "rules": [
      {
        "type": "field",
        "ip": ["geoip:private"],
        "outboundTag": "direct"
      },
      {
        "type": "field",
        "ip": ["geoip:ru"],
        "outboundTag": "direct"
      }
    ]
  }
}`}
                      </div>
                    </div>
                  </div>
                </div>

                <div className="setup-section">
                  <button
                    className={`section-header ${activeIndex === 8 ? 'active' : ''}`}
                    onClick={() => toggleSection(8)}
                  >
                    <h3>ШАГ 9: Создание скрипта автозапуска</h3>
                    <span className="section-icon">
                      {activeIndex === 8 ? '−' : '+'}
                    </span>
                  </button>
                  
                  <div className={`section-content ${activeIndex === 8 ? 'active' : ''}`}>
                    <div className="section-content-inner">
                      <div className="router-code-block">
{`# Создайте скрипт автозапуска
nano /opt/etc/init.d/S24xray

# Вставьте содержимое:
#!/bin/sh
ENABLED=yes
PROCS=xray
ARGS="-config /opt/etc/xray/config.json"
PREARGS=""
DESC=$PROCS
PATH=/opt/sbin:/opt/bin:/usr/local/sbin:/usr/local/bin:/usr/sbin:/usr/bin:/sbin:/bin

. /opt/etc/init.d/rc.func

# Сделайте исполняемым
chmod +x /opt/etc/init.d/S24xray

# Запустите Xray
/opt/etc/init.d/S24xray start

# Проверьте статус
/opt/etc/init.d/S24xray check`}
                      </div>
                    </div>
                  </div>
                </div>

                <div className="setup-section">
                  <button
                    className={`section-header ${activeIndex === 9 ? 'active' : ''}`}
                    onClick={() => toggleSection(9)}
                  >
                    <h3>ШАГ 10: Настройка маршрутизации трафика</h3>
                    <span className="section-icon">
                      {activeIndex === 9 ? '−' : '+'}
                    </span>
                  </button>
                  
                  <div className={`section-content ${activeIndex === 9 ? 'active' : ''}`}>
                    <div className="section-content-inner">
                      <p>Это самая сложная часть - настройка перенаправления трафика через Xray.</p>
                      
                      <div className="router-code-block">
{`# Создайте маркировку пакетов
iptables -t mangle -A OUTPUT -p tcp --dport 80,443 -j MARK --set-mark 1
iptables -t mangle -A OUTPUT -p udp --dport 53 -j MARK --set-mark 1

# Перенаправление на Xray
iptables -t nat -A OUTPUT -p tcp -m mark --mark 1 -j REDIRECT --to-ports 12345

# Сохранение правил
iptables-save > /opt/etc/iptables.rules`}
                      </div>
                      
                      <p><strong>Внимание:</strong> Неправильная настройка iptables может полностью заблокировать интернет. Рекомендуется изучить документацию Keenetic по настройке межсетевого экрана.</p>
                    </div>
                  </div>
                </div>

                <div className="tab-text-content">
                  <h1>Готово! Keenetic с VPN настроен</h1>
                  <p>Теперь весь трафик должен проходить через VPN. Для проверки используйте whoer.net (не 2ip.ru, так как российские сайты могут идти в обход VPN).</p>
                </div>
              </>
            )}

            {/* ASUS Merlin Tab */}
            {/* ASUS Merlin Tab */}
{activeTab === 1 && (
  <>
    <div className="tab-text-content">
      <p>ASUS Merlin - продвинутый вариант для роутеров ASUS. Требует прошивки альтернативной системы Asuswrt-Merlin и установки Entware.</p>
      
      <h1>Поддерживаемые модели ASUS</h1>
      
      <p><strong>✅ Полная поддержка (рекомендуемые):</strong><br/>
      • RT-AX88U (от 25000₽) - топовая модель WiFi 6<br/>
      • RT-AX86U (от 20000₽) - популярная модель<br/>
      • RT-AX58U (от 15000₽) - средний сегмент<br/>
      • RT-AC88U, RT-AC86U, RT-AC68U - проверенные временем<br/>
      • GT-AX11000, GT-AC5300 - игровые модели<br/>
      • RT-AX82U, RT-AX92U - новые модели</p>
      
      <p><strong>❌ НЕ поддерживаются:</strong><br/>
      • Модели на чипах MediaTek (RT-AX55, RT-AX56U)<br/>
      • Бюджетные серии (RT-N66U, RT-AC750)<br/>
      • Старые модели без ARM процессора<br/>
      • Mesh системы ZenWiFi</p>
      
      <p><strong>ВНИМАНИЕ:</strong> Процесс прошивки ASUS рискован. Неправильная прошивка может окончательно повредить роутер!</p>
    </div>

    <div className="setup-section">
      <button
        className={`section-header ${activeIndex === 10 ? 'active' : ''}`}
        onClick={() => toggleSection(10)}
      >
        <h3>ШАГ 1: Подготовка роутера ASUS</h3>
        <span className="section-icon">
          {activeIndex === 10 ? '−' : '+'}
        </span>
      </button>
      
      <div className={`section-content ${activeIndex === 10 ? 'active' : ''}`}>
        <div className="section-content-inner">
          <ol className="steps-list">
            <li>Подключите роутер к компьютеру кабелем Ethernet</li>
            <li>Войдите в стандартный интерфейс ASUS: http://192.168.1.1</li>
            <li>Логин: admin, пароль: admin (или тот что вы установили)</li>
            <li>Перейдите в "Администрирование" → "Восстановление/Сохранение настроек"</li>
            <li>Нажмите "Сохранить настройки" и скачайте backup файл</li>
            <li>Запишите точную модель роутера (например RT-AX86U) и версию прошивки</li>
            <li>Убедитесь в стабильном питании роутера (лучше через UPS)</li>
          </ol>
          <p><strong>КРИТИЧНО:</strong> Backup - это ваша страховка. Без него восстановление может быть невозможно!</p>
        </div>
      </div>
    </div>

    <div className="setup-section">
      <button
        className={`section-header ${activeIndex === 11 ? 'active' : ''}`}
        onClick={() => toggleSection(11)}
      >
        <h3>ШАГ 2: Скачивание Asuswrt-Merlin</h3>
        <span className="section-icon">
          {activeIndex === 11 ? '−' : '+'}
        </span>
      </button>
      
      <div className={`section-content ${activeIndex === 11 ? 'active' : ''}`}>
        <div className="section-content-inner">
          <ol className="steps-list">
            <li>Откройте официальный сайт: https://asuswrt.lostrealm.ca/</li>
            <li>Перейдите в раздел "Download"</li>
            <li>Найдите ТОЧНО вашу модель роутера в списке</li>
            <li>Скачайте последнюю стабильную версию (.trx файл)</li>
            <li>Проверьте размер файла - он должен быть 30-50MB</li>
            <li>НЕ скачивайте beta версии для первой установки</li>
          </ol>
          <p><strong>Пример:</strong> Для RT-AX86U скачайте файл типа "RT-AX86U_388.4_0.trx"</p>
          <p><strong>ВНИМАНИЕ:</strong> Файл для другой модели превратит ваш роутер в "кирпич"!</p>
        </div>
      </div>
    </div>

    <div className="setup-section">
      <button
        className={`section-header ${activeIndex === 12 ? 'active' : ''}`}
        onClick={() => toggleSection(12)}
      >
        <h3>ШАГ 3: Прошивка Asuswrt-Merlin</h3>
        <span className="section-icon">
          {activeIndex === 12 ? '−' : '+'}
        </span>
      </button>
      
      <div className={`section-content ${activeIndex === 12 ? 'active' : ''}`}>
        <div className="section-content-inner">
          <ol className="steps-list">
            <li>В веб-интерфейсе ASUS перейдите: "Администрирование" → "Обновление прошивки"</li>
            <li>Нажмите "Выберите файл" и укажите скачанный .trx файл</li>
            <li>Убедитесь что выбран правильный файл и размер совпадает</li>
            <li>Нажмите "Загрузить" (Upload)</li>
            <li>Начнется процесс прошивки - НЕ ВЫКЛЮЧАЙТЕ роутер!</li>
            <li>Ждите 5-10 минут, роутер перезагрузится автоматически</li>
            <li>После перезагрузки зайдите на http://192.168.1.1</li>
            <li>Если интерфейс изменился - прошивка прошла успешно</li>
          </ol>
          <p><strong>КРИТИЧНО:</strong> Не выключайте питание во время прошивки! Это гарантированно убьет роутер.</p>
          <p><strong>Если что-то пошло не так:</strong> Попробуйте восстановление через режим Recovery Mode (держите Reset при включении).</p>
        </div>
      </div>
    </div>

    <div className="setup-section">
      <button
        className={`section-header ${activeIndex === 13 ? 'active' : ''}`}
        onClick={() => toggleSection(13)}
      >
        <h3>ШАГ 4: Первоначальная настройка Merlin</h3>
        <span className="section-icon">
          {activeIndex === 13 ? '−' : '+'}
        </span>
      </button>
      
      <div className={`section-content ${activeIndex === 13 ? 'active' : ''}`}>
        <div className="section-content-inner">
          <ol className="steps-list">
            <li>При первом входе пройдите мастер настройки</li>
            <li>Настройте WiFi сети и пароли</li>
            <li>Настройте подключение к интернету (WAN)</li>
            <li>Перейдите в "Администрирование" → "Система"</li>
            <li>Включите "Enable SSH" → "Yes"</li>
            <li>Установите "Allow SSH port forwarding" → "Yes"</li>
            <li>Задайте пароль для SSH (можно тот же что для админки)</li>
            <li>Нажмите "Применить" и дождитесь перезагрузки</li>
          </ol>
        </div>
      </div>
    </div>

    <div className="setup-section">
      <button
        className={`section-header ${activeIndex === 14 ? 'active' : ''}`}
        onClick={() => toggleSection(14)}
      >
        <h3>ШАГ 5: Подготовка USB накопителя</h3>
        <span className="section-icon">
          {activeIndex === 14 ? '−' : '+'}
        </span>
      </button>
      
      <div className={`section-content ${activeIndex === 14 ? 'active' : ''}`}>
        <div className="section-content-inner">
          <ol className="steps-list">
            <li>Возьмите USB флешку 8GB+ (лучше USB 3.0)</li>
            <li>Отформатируйте в файловую систему EXT4 или EXT3</li>
            <li>В Windows используйте программу "MiniTool Partition Wizard"</li>
            <li>Или в Linux: sudo mkfs.ext4 /dev/sdX1</li>
            <li>Подключите флешку к USB порту роутера</li>
            <li>В веб-интерфейсе перейдите в "USB приложения"</li>
            <li>Убедитесь что флешка определилась</li>
          </ol>
          <p><strong>Примечание:</strong> EXT4 не читается в Windows - это нормально для Linux систем.</p>
        </div>
      </div>
    </div>

    <div className="setup-section">
      <button
        className={`section-header ${activeIndex === 15 ? 'active' : ''}`}
        onClick={() => toggleSection(15)}
      >
        <h3>ШАГ 6: Установка Entware</h3>
        <span className="section-icon">
          {activeIndex === 15 ? '−' : '+'}
        </span>
      </button>
      
      <div className={`section-content ${activeIndex === 15 ? 'active' : ''}`}>
        <div className="section-content-inner">
          <ol className="steps-list">
            <li>Подключитесь к роутеру по SSH из терминала/PuTTY</li>
            <li>Выполните команды для установки Entware:</li>
          </ol>
          
          <div className="router-code-block">
{`# Подключение по SSH
ssh admin@192.168.1.1

# Введите пароль администратора

# Установка Entware автоматически
curl -L https://entware.net/binaries/armv7/installer/generic.sh | sh

# Или вручную для ARM роутеров:
wget -O - http://bin.entware.net/armv7sf-k3.2/installer/generic.sh | sh

# Обновление списка пакетов
opkg update

# Проверка установки
opkg list | head`}
          </div>
          
          <ol className="steps-list" start="3">
            <li>Дождитесь завершения установки (5-10 минут)</li>
            <li>При успехе увидите сообщение о завершении</li>
            <li>Теперь доступен менеджер пакетов opkg</li>
          </ol>
        </div>
      </div>
    </div>

    <div className="setup-section">
      <button
        className={`section-header ${activeIndex === 16 ? 'active' : ''}`}
        onClick={() => toggleSection(16)}
      >
        <h3>ШАГ 7: Установка Xray</h3>
        <span className="section-icon">
          {activeIndex === 16 ? '−' : '+'}
        </span>
      </button>
      
      <div className={`section-content ${activeIndex === 16 ? 'active' : ''}`}>
        <div className="section-content-inner">
          <div className="router-code-block">
{`# Установка необходимых пакетов
opkg install curl wget unzip nano

# Скачивание Xray для ARM архитектуры
cd /tmp
wget https://github.com/XTLS/Xray-core/releases/download/v1.8.6/Xray-linux-arm64-v8a.zip

# Для более старых роутеров используйте:
# wget https://github.com/XTLS/Xray-core/releases/download/v1.8.6/Xray-linux-arm32-v7a.zip

# Распаковка и установка
unzip Xray-linux-arm64-v8a.zip
cp xray /opt/usr/bin/
chmod +x /opt/usr/bin/xray

# Создание папок для конфигурации
mkdir -p /opt/etc/xray
mkdir -p /opt/var/log/xray

# Проверка установки
/opt/usr/bin/xray version`}
          </div>
        </div>
      </div>
    </div>

    <div className="setup-section">
      <button
        className={`section-header ${activeIndex === 17 ? 'active' : ''}`}
        onClick={() => toggleSection(17)}
      >
        <h3>ШАГ 8: Получение и настройка VLESS конфигурации</h3>
        <span className="section-icon">
          {activeIndex === 17 ? '−' : '+'}
        </span>
      </button>
      
      <div className={`section-content ${activeIndex === 17 ? 'active' : ''}`}>
        <div className="section-content-inner">
          <p><strong>Получение конфигурации:</strong></p>
          <ol className="steps-list">
            <li>Откройте Telegram бот RED BUTTON</li>
            <li>Перейдите в "Мои конфигурации" → "Отдельные конфиги"</li>
            <li>Скопируйте VLESS строку (не subscription link!)</li>
            <li>Расшифруйте параметры как в инструкции для Keenetic</li>
          </ol>
          
          <p><strong>Создание конфигурации:</strong></p>
          <div className="router-code-block">
{`# Создание конфиг файла
nano /opt/etc/xray/config.json

# Вставьте JSON конфигурацию (аналогично Keenetic)
# Замените параметры на ваши из VLESS строки`}
          </div>
        </div>
      </div>
    </div>

    <div className="setup-section">
      <button
        className={`section-header ${activeIndex === 18 ? 'active' : ''}`}
        onClick={() => toggleSection(18)}
      >
        <h3>ШАГ 9: Автозапуск и маршрутизация</h3>
        <span className="section-icon">
          {activeIndex === 18 ? '−' : '+'}
        </span>
      </button>
      
      <div className={`section-content ${activeIndex === 18 ? 'active' : ''}`}>
        <div className="section-content-inner">
          <div className="router-code-block">
{`# Создание скрипта автозапуска
nano /opt/etc/init.d/S99xray

# Содержимое скрипта:
#!/bin/sh
case "$1" in
  start)
    echo "Starting Xray..."
    /opt/usr/bin/xray run -config /opt/etc/xray/config.json &
    ;;
  stop)
    echo "Stopping Xray..."
    killall xray
    ;;
  restart)
    $0 stop
    sleep 2
    $0 start
    ;;
  *)
    echo "Usage: $0 {start|stop|restart}"
    exit 1
    ;;
esac

# Сделать исполняемым
chmod +x /opt/etc/init.d/S99xray

# Настройка iptables для перенаправления трафика
# (Сложная часть, требует знания сетей)
iptables -t nat -A OUTPUT -p tcp --dport 80,443 -j REDIRECT --to-ports 12345
iptables -t nat -A OUTPUT -p tcp --dport 853 -j REDIRECT --to-ports 12345

# Запуск Xray
/opt/etc/init.d/S99xray start`}
          </div>
        </div>
      </div>
    </div>

    <div className="tab-text-content">
      <h1>Готово! ASUS Merlin настроен</h1>
      <p>После настройки весь трафик должен идти через VPN. Для проверки используйте whoer.net.</p>
      
      <p><strong>Особенности ASUS Merlin:</strong><br/>
      • Стабильность стоковой прошивки + возможности OpenWrt<br/>
      • Регулярные обновления безопасности<br/>
      • Сохранение гарантийного веб-интерфейса<br/>
      • Хорошая документация и сообщество</p>
      
      <p><strong>Troubleshooting:</strong><br/>
      • Если Xray не запускается - проверьте архитектуру процессора<br/>
      • Если нет интернета - проверьте iptables правила<br/>
      • Для отката - восстановите backup стоковой прошивки</p>
    </div>
  </>
)}

            {/* OpenWrt Tab */}
            {activeTab === 2 && (
              <>
                <div className="tab-text-content">
                  <p>OpenWrt - самый сложный, но универсальный вариант. Поддерживает множество моделей роутеров, но требует серьезных технических знаний.</p>
                  
                  <h1>Популярные модели для OpenWrt</h1>
                  
                  <p><strong>✅ TP-Link (проще всего прошивать):</strong><br/>
                  • Archer C6 v2/v3, Archer A6 v2/v3 - отличные для новичков<br/>
                  • Archer C7 v4/v5 - проверенные модели<br/>
                  • WR1043ND v4 - бюджетный вариант</p>
                  
                  <p><strong>✅ Xiaomi (хорошее соотношение цена/качество):</strong><br/>
                  • Mi Router 4A Gigabit Edition - популярная модель<br/>
                  • Mi Router 3G v1 - стабильная работа<br/>
                  • Mi Router AC2100 - WiFi 6 поддержка</p>
                  
                  <p><strong>✅ GL.iNet (готовые решения):</strong><br/>
                  • GL-AX1800 (Flint) - предустановленный OpenWrt<br/>
                  • GL-MT6000 (Flint 2) - новая модель WiFi 6<br/>
                  • Travel роутеры серии MT</p>
                  
                  <p><strong>МАКСИМАЛЬНЫЙ РИСК:</strong> OpenWrt полностью заменяет заводскую прошивку. Ошибка может превратить роутер в "кирпич" без возможности восстановления!</p>
                </div>

                <div className="setup-section">
                  <button
                    className={`section-header ${activeIndex === 13 ? 'active' : ''}`}
                    onClick={() => toggleSection(13)}
                  >
                    <h3>ШАГ 1: Проверка совместимости и подготовка</h3>
                    <span className="section-icon">
                      {activeIndex === 13 ? '−' : '+'}
                    </span>
                  </button>
                  
                  <div className={`section-content ${activeIndex === 13 ? 'active' : ''}`}>
                    <div className="section-content-inner">
                      <ol className="steps-list">
                        <li>Проверьте совместимость на официальном сайте OpenWrt.org</li>
                        <li>Скачайте точный образ прошивки для вашей модели и ревизии</li>
                        <li>Создайте резервную копию заводской прошивки (ОБЯЗАТЕЛЬНО!)</li>
                        <li>Убедитесь в стабильном питании роутера</li>
                        <li>Подготовьте план восстановления на случай сбоя</li>
                      </ol>
                      <p><strong>ВНИМАНИЕ:</strong> Неточный образ прошивки может полностью вывести роутер из строя!</p>
                    </div>
                  </div>
                </div>

                <div className="setup-section">
                  <button
                    className={`section-header ${activeIndex === 14 ? 'active' : ''}`}
                    onClick={() => toggleSection(14)}
                  >
                    <h3>ШАГ 2: Прошивка OpenWrt</h3>
                    <span className="section-icon">
                      {activeIndex === 14 ? '−' : '+'}
                    </span>
                  </button>
                  
                  <div className={`section-content ${activeIndex === 14 ? 'active' : ''}`}>
                    <div className="section-content-inner">
                      <ol className="steps-list">
                        <li>Подключите роутер кабелем к компьютеру</li>
                        <li>Войдите в веб-интерфейс роутера (обычно 192.168.1.1)</li>
                        <li>Найдите раздел обновления прошивки</li>
                        <li>Загрузите файл OpenWrt (.bin формат)</li>
                        <li>Дождитесь завершения прошивки (5-10 минут)</li>
                        <li>Роутер перезагрузится с OpenWrt</li>
                      </ol>
                      <p><strong>КРИТИЧНО:</strong> НЕ ВЫКЛЮЧАЙТЕ роутер во время прошивки!</p>
                    </div>
                  </div>
                </div>

                <div className="setup-section">
                  <button
                    className={`section-header ${activeIndex === 15 ? 'active' : ''}`}
                    onClick={() => toggleSection(15)}
                  >
                    <h3>ШАГ 3: Установка PassWall или luci-app-xray</h3>
                    <span className="section-icon">
                      {activeIndex === 15 ? '−' : '+'}
                    </span>
                  </button>
                  
                  <div className={`section-content ${activeIndex === 15 ? 'active' : ''}`}>
                    <div className="section-content-inner">
                      <p><strong>Вариант 1: PassWall (рекомендуется для новичков)</strong></p>
                      <div className="router-code-block">
{`# Подключитесь к роутеру по SSH
ssh root@192.168.1.1

# Добавьте репозиторий PassWall
wget -O passwall.pub https://master.dl.sourceforge.net/project/openwrt-passwall-build/passwall.pub
opkg-key add passwall.pub
echo 'src/gz passwall_core https://master.dl.sourceforge.net/project/openwrt-passwall-build/releases/packages-23.05' >> /etc/opkg/customfeeds.conf

# Обновите списки пакетов
opkg update

# Установите PassWall и зависимости
opkg install luci-app-passwall xray-core`}
                      </div>
                      
                      <p><strong>Вариант 2: luci-app-xray (для продвинутых)</strong></p>
                      <div className="router-code-block">
{`# Установка через opkg
opkg update
opkg install luci-app-xray xray-core v2ray-geoip v2ray-geosite`}
                      </div>
                    </div>
                  </div>
                </div>

                <div className="tab-text-content">
                  <p>После установки PassWall или luci-app-xray настройка аналогична другим вариантам - добавление VLESS конфигурации, настройка маршрутизации и проксирования трафика.</p>
                  <p><strong>Преимущества OpenWrt:</strong> Максимальная гибкость, поддержка множества моделей, активное сообщество разработчиков.</p>
                </div>
              </>
            )}

            {/* AdGuard DNS Section */}
            <div className="tab-text-content">
              <h1>🛡️ Дополнительная защита: AdGuard DNS</h1>
              <p>Для усиленной защиты рекомендуется также настроить AdGuard DNS:</p>
              
              <div className="setup-section">
                <button
                  className={`section-header ${activeIndex === 16 ? 'active' : ''}`}
                  onClick={() => toggleSection(16)}
                >
                  <h3>Настройка AdGuard DNS</h3>
                  <span className="section-icon">
                    {activeIndex === 16 ? '−' : '+'}
                  </span>
                </button>
                
                <div className={`section-content ${activeIndex === 16 ? 'active' : ''}`}>
                  <div className="section-content-inner">
                    <ol className="steps-list">
                      <li>В веб-интерфейсе роутера перейдите в настройки DNS</li>
                      <li>Отключите автоматическое получение DNS от провайдера</li>
                      <li>Укажите серверы AdGuard:
                        <ul>
                          <li><strong>Основной:</strong> 94.140.14.14</li>
                          <li><strong>Альтернативный:</strong> 94.140.15.15</li>
                        </ul>
                      </li>
                      <li>Сохраните настройки и перезагрузите роутер</li>
                    </ol>
                    
                    <p><strong>Что делает AdGuard DNS:</strong><br/>
                    • Автоматически блокирует рекламу на всех устройствах<br/>
                    • Защищает от трекеров и вредоносных сайтов<br/>
                    • Работает на уровне DNS, не требуя установки приложений<br/>
                    • Особенно полезно для Smart TV, игровых приставок и IoT устройств</p>
                  </div>
                </div>
              </div>
            </div>

            {/* Final Notes */}
            <div className="tab-text-content">
              <h1>🎯 Заключение</h1>
              <p>Настройка VPN на роутере - сложный технический процесс, который обеспечивает автоматическую защиту всех устройств в сети. Рекомендуется начинать с Keenetic как наиболее безопасного варианта.</p>
              
              <p><strong>После успешной настройки вы получите:</strong><br/>
              • Автоматическую VPN защиту для всех устройств<br/>
              • Обход блокировок на уровне сети<br/>
              • Защиту Smart TV, игровых приставок и других устройств<br/>
              • Централизованное управление VPN подключением</p>
              
              <p><strong>Помните:</strong> Если что-то пошло не так, всегда можно восстановить заводскую прошивку из резервной копии (если она была создана заранее).</p>
            </div>

          </div>
        </div>
      </section>
      <Footer />
    </div>
  );
};

export default SetupRouterPage;